module.exports = __webpack_public_path__ + "static/images/callout_2.13158204d00541f147260824a61b0240.jpg";